/**
 * Moderation queue registry — the four queues the sidebar exposes under
 * ЕДА / Модерация. All four read the unified admin queue
 * (`GET /api/v1/admin/change-requests`, filtered by `entity_type`) and
 * resolve the review card (`{prod, manual, sync}`) through their per-entity
 * card path from `openapi-eats-admin.json`. Adding a queue (banners,
 * modifier groups) is one entry here plus a sidebar child + route.
 */

export const MODERATION_ENTITY_TYPES = {
  restaurants: {
    /** `entity_type` filter value on the unified change-request queue. */
    queueEntityType: 'restaurant',
    /** `GET` path of the entity's review card (`v1RestaurantModerationCard`). */
    cardPath: (id: string) => `/api/v1/admin/restaurants/${id}/moderations`,
    route: '/moderation/restaurants',
    navKey: 'nav.restaurants',
    title: 'restaurantsTitle',
  },
  products: {
    queueEntityType: 'product',
    cardPath: (id: string) => `/api/v1/admin/products/${id}/moderations`,
    route: '/moderation/products',
    navKey: 'nav.products',
    title: 'productsTitle',
  },
  categories: {
    queueEntityType: 'product_category',
    cardPath: (id: string) => `/api/v1/admin/product-categories/${id}/moderations`,
    route: '/moderation/categories',
    navKey: 'nav.categories',
    title: 'categoriesTitle',
  },
  promotions: {
    queueEntityType: 'promotion',
    cardPath: (id: string) => `/api/v1/admin/promotions/${id}/moderations`,
    route: '/moderation/promotions',
    navKey: 'nav.discounts',
    title: 'promotionsTitle',
  },
} as const;

export type ModerationEntityType = keyof typeof MODERATION_ENTITY_TYPES;

export const MODERATION_ENTITY_ORDER: readonly ModerationEntityType[] = [
  'restaurants',
  'products',
  'categories',
  'promotions',
];
